import { createSlice } from "@reduxjs/toolkit";

export const fcmSlice = createSlice({
  name: "fcmToken",
  initialState: {
    value: null,
  },
  reducers: {
    storeFcm: (state, action) => {
      state.value = action.payload;
    },
    deleteFcm: (state) => {
      state.value = null;
    },
  },
});

export const { storeFcm, deleteFcm } = fcmSlice.actions;

export default fcmSlice.reducer;
